import Experience from "./experience/Experience";

// Canvas
const canvas = document.querySelector('canvas.webgl')

const experience = new Experience(canvas);